// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1bvwZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__2YC7Y"};